(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

$(function () {
  var max = $(document).height() - $(window).height();
  var $progressBar = $('#progress-bar');

  if ($progressBar.length > 0) {
    $(window).on('load', function () {
      max = $(document).height() - $(window).height();
      $progressBar.attr('max', max);
    });
    $(window).ready(function () {
      max = $(document).height() - $(window).height();
      $progressBar.attr('max', max);
    });
    var value = $(window).scrollTop();
    $progressBar.attr('max', max);
    $progressBar.attr('value', value);
    $(document).on('scroll', function () {
      value = $(window).scrollTop();
      $progressBar.attr('value', value);

      if (value >= max) {
        $progressBar.addClass('comlpeted');
      } else if (value < 55) {
        $progressBar.addClass('starting');
      } else {
        if ($progressBar.hasClass('comlpeted')) {
          $progressBar.removeClass('comlpeted');
        }

        if ($progressBar.hasClass('starting')) {
          $progressBar.removeClass('starting');
        }
      }
    });
  }
});

},{}],2:[function(require,module,exports){
"use strict";

require("./components/progress-bar");

},{"./components/progress-bar":1}]},{},[2]);
